import { trapFocus, removeTrapFocus } from '@shopify/theme-a11y';

const selectors = {
  header: '.site-header',
  mainNav: '[data-js-main-nav]',
  menuItemBack: '[data-js-nav-item-back]',
  menuItemContent: '[data-js-nav-item-content]',
  menuItemLink: '[data-js-nav-item-link]',
  menuNavToggler: '[data-js-nav-main-toggler]',
  mobileNavClose: '[data-js-mobile-nav-close]',
  mobileNavOpen: '[data-js-mobile-nav-open]',
  mobileNavToggle: '[data-js-mobile-nav-toggle]',
};

const dom = {};

const cacheDom = () => {
  dom.header = document.querySelector(selectors.header);
  dom.mainNav = dom.header.querySelector(selectors.mainNav);
  dom.menuNavToggler = [
    ...dom.header.querySelectorAll(selectors.menuNavToggler),
  ];
  dom.menuItemLink = [...dom.header.querySelectorAll(selectors.menuItemLink)];
  dom.menuItemContent = [
    ...dom.header.querySelectorAll(selectors.menuItemContent),
  ];
  dom.menuItemBack = [...dom.header.querySelectorAll(selectors.menuItemBack)];
  dom.mobileNavToggle = dom.header.querySelector(selectors.mobileNavToggle);
  dom.mobileNavOpen = dom.header.querySelector(selectors.mobileNavOpen);
  dom.mobileNavClose = [
    ...dom.header.querySelectorAll(selectors.mobileNavClose),
  ];
};

const openMobileNav = () => {
  document.body.classList.add('mobile-nav-opened');
  dom.mainNav.setAttribute('aria-hidden', false);
  dom.mobileNavToggle.setAttribute('aria-expanded', true);

  trapFocus(dom.mainNav);

  // Lock Body scroll
  document.body.classList.add('overflow-hidden');
};

const closeMobileNav = () => {
  document.body.classList.remove('mobile-nav-opened');
  dom.mainNav && dom.mainNav.setAttribute('aria-hidden', true);
  dom.mobileNavToggle &&
    dom.mobileNavToggle.setAttribute('aria-expanded', false);

  removeTrapFocus(dom.mainNav);

  // Close all sub menus
  dom.menuItemContent.forEach((subMenu) => {
    subMenu.setAttribute('aria-hidden', true);
  });

  // Enable body scroll
  document.body.classList.remove('overflow-hidden');
};

const openChildNav = (event) => {
  event.preventDefault();
  const menuItem = event.currentTarget.parentNode;
  menuItem
    .querySelector(selectors.menuItemContent)
    .setAttribute('aria-hidden', false);
  event.currentTarget.setAttribute('aria-expanded', true);
};

const closeChildNav = (event) => {
  event.preventDefault();
  const menuItem = event.currentTarget.closest('.nav-item');
  const menuContainer = event.currentTarget.closest('.nav-item__child-content');
  if (menuContainer != null) {
    menuContainer.setAttribute('aria-hidden', true);
  } else {
    menuItem
      .querySelector(selectors.menuItemContent)
      .setAttribute('aria-hidden', true);
    menuItem
      .querySelector(selectors.menuItemLink)
      .setAttribute('aria-expanded', false);
  }
};

const resetNavigation = () => {
  const height = dom.header.offsetHeight - 1;
  document.documentElement.style.setProperty('--header-height', `${height}px`);

  window.addEventListener('resize', () => {
    const height = dom.header.offsetHeight - 1;
    document.documentElement.style.setProperty(
      '--header-height',
      `${height}px`,
    );
    if (window.innerWidth >= 1200) {
      closeMobileNav();
    }
  });
};

const handleNavigationEvents = () => {
  if (dom.mainNav) {
    // Desktop Nav Events
    if (window.innerWidth >= 1200) {
      dom.menuNavToggler.forEach((link) => {
        link.addEventListener('mouseenter', (event) => {
          document.body.classList.add('nav-opened');
        });

        link.addEventListener('mouseleave', (event) => {
          document.body.classList.remove('nav-opened');
        });
      });
    }

    // Mobile Nav Events
    // Click Menu Item Link
    dom.menuItemLink.forEach((button) => {
      button.addEventListener('click', (event) => {
        if (window.innerWidth < 1200) {
          openChildNav(event);
        }
      });
    });

    // Click Menu Item Back button
    dom.menuItemBack.forEach((button) => {
      button.addEventListener('click', (event) => {
        closeChildNav(event);
      });
    });

    dom.mobileNavToggle &&
      dom.mobileNavToggle.addEventListener('click', (event) => {
        event.preventDefault();
        if (!document.body.classList.contains('mobile-nav-opened')) {
          openMobileNav();
        } else {
          closeMobileNav();
        }
      });

    dom.mobileNavOpen &&
      dom.mobileNavOpen.addEventListener('click', (event) => {
        event.preventDefault();
        openMobileNav();
      });

    dom.mobileNavClose.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        closeMobileNav();
      });
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest(selectors.header)) {
        closeMobileNav();
      }
    });
  }
};

const siteHeader = {
  init() {
    cacheDom();
    resetNavigation();
    handleNavigationEvents();
  },
};

export default siteHeader;
